export enum CommissionRateType {
  Percentage = 0,
  Flat = 1,
  PercentageFlat = 2,
  Tiered = 3,
}
